import React from 'react';

const BulkActionsToolbar = ({
  selectedLines,
  bulkEditMode,
  bulkValues,
  conditionOptions,
  certificationOptions,
  saving,
  onClearSelection,
  onToggleBulkEditMode,
  onBulkValuesChange,
  onApplyBulkChanges,
  onQuickBulkAction,
  onBulkNoQuote
}) => {
  if (selectedLines.size === 0) return null;

  const handleConditionChange = (e) => {
    onBulkValuesChange({ ...bulkValues, condition: e.target.value });
  };

  const handleCertificationChange = (e) => {
    onBulkValuesChange({ ...bulkValues, certification: e.target.value });
  };

  const handleLeadTimeChange = (e) => {
    onBulkValuesChange({ ...bulkValues, lead_time: e.target.value });
  };

  const handleFactoryNewOEM = () => {
    onQuickBulkAction({ condition: 'FN', certification: 'OEM', lead_time: '', vendor_id: '' });
  };

  const handleOverhauled8130 = () => {
    onQuickBulkAction({ condition: 'OH', certification: '8130', lead_time: '', vendor_id: '' });
  };

  return (
    <div className="bulk-actions-toolbar" role="region" aria-label="Bulk actions">
      <div className="bulk-info">
        <span aria-live="polite">{selectedLines.size} lines selected</span>
        <button onClick={onClearSelection}>Clear Selection</button>
      </div>
      
      <div className="bulk-controls">
        <button
          onClick={onToggleBulkEditMode}
          className={bulkEditMode ? 'active' : ''}
          aria-pressed={bulkEditMode}
        >
          {bulkEditMode ? 'Cancel Bulk Edit' : 'Bulk Edit'}
        </button>
        
        {bulkEditMode && (
          <>
            <label htmlFor="bulk-condition" className="sr-only">Bulk condition</label>
            <select
              id="bulk-condition"
              value={bulkValues.condition}
              onChange={handleConditionChange}
            >
              <option value="">Condition...</option>
              {conditionOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>

            <label htmlFor="bulk-certification" className="sr-only">Bulk certification</label>
            <select
              id="bulk-certification"
              value={bulkValues.certification}
              onChange={handleCertificationChange}
            >
              <option value="">Certification...</option>
              {certificationOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>

            <label htmlFor="bulk-leadtime" className="sr-only">Bulk lead time</label>
            <input
              id="bulk-leadtime"
              type="number"
              placeholder="Lead time..."
              value={bulkValues.lead_time}
              onChange={handleLeadTimeChange}
            />

            <button onClick={onApplyBulkChanges} disabled={saving}>
              Apply to {selectedLines.size} lines
            </button>
          </>
        )}
      </div>

      <div className="quick-bulk-actions" role="group" aria-label="Quick bulk actions">
        <button
          onClick={handleFactoryNewOEM}
          aria-label="Set all selected lines to Factory New condition with OEM certification"
        >
          Set Factory New/OEM
        </button>
        <button
          onClick={handleOverhauled8130}
          aria-label="Set all selected lines to Overhauled condition with 8130 certification"
        >
          Set Overhauled/8130
        </button>
        <button
          onClick={onBulkNoQuote}
          disabled={saving}
          className="no-quote-bulk-btn"
          aria-label="Mark all selected lines as No Quote with price set to 0"
        >
          Mark as No Quote
        </button>
      </div>
    </div>
  );
};

export default BulkActionsToolbar;